module.exports = __webpack_public_path__ + "img/reco-nav-image-general.8937df1f.svg";